import { invertColor } from './_lib/invertColor.js';
import { hex2rgb } from './_lib/hex2rgb.js';
import { shuffle } from './_lib/shuffle.js';

export let bgAnime = {
  wrapper: document.getElementById('wrapper'),
  apex: ['A', 'B', 'C', 'D'],
  colors: ['#310082', '#002A97', '#370051', '#004166', '#004E40'],
  speed: 60000,
  delay: 1000,
  interval: 5000,
  timer: '',
  colorTimer: '',
  count: 0,
  random: (min, max)=>{
    return Math.floor( Math.random() * (max + 1 - min) ) + min ;
  },
  set: ()=>{
    //頂点の位置をランダムにセット
    bgAnime.apex.forEach((elm) => {
      let point = bgAnime.random(20, 80);
      bgAnime.wrapper.style.setProperty('--apex-' + elm, point + '%');
    });
  },
  colorSet: ()=>{
    if(bgAnime.count < bgAnime.colors.length - 1){
      bgAnime.count++;
    }else{
      bgAnime.count = 0;
    }
    let bgColor = bgAnime.colors[bgAnime.count];
    let textColor = invertColor(hex2rgb(bgAnime.colors[bgAnime.count])); //HEX色をrgbに変換し、反転色を算出してテキストカラーに設定
    document.body.style.setProperty('--bgColor', bgColor);
    document.body.style.setProperty('--textColor', 'rgb('+ textColor +')');
  },
  init: ()=>{
    document.body.style.setProperty('--animation-speed', bgAnime.speed + 'ms');
    document.body.style.setProperty('--animation-delay', bgAnime.delay + 'ms');
    //背景色class変数をセット
    bgAnime.colors = shuffle(bgAnime.colors);
  }
}
